module.exports = __webpack_public_path__ + "static/media/background-right-desktop.5f2f4618.svg";